import { IAppState } from './../../types/reducers/state';

export const selectPublishDays = (state: IAppState) => state.publishTerms?.publication.period?.days;
